import React from 'react'
import DUMMYITEM from '../sections/DUMMYITEM'

function Collection() {
    return <DUMMYITEM />
}

export default Collection